import { DataField } from "@iventis/domain-model/model/dataField";

export type ModalState = "delete" | "share" | "export" | "copy" | "unlink" | "importGeoJson" | "addAttributes" | "exportDwg" | null;

export interface SidebarReducerState {
    isObjectDetailsMinimised: boolean;
    transitionCompleted: boolean;
    showAttributeModal: boolean;
    attributeDataField: DataField;
    modal: ModalState;
}

export enum SidebarReducerActionName {
    setObjectDetailsMinimised = "setObjectDetailsMinimised",
    setTransitionCompleted = "setTransitionCompleted",
    setShowAttributeModal = "setShowAttributeModal",
    setAttributeDataField = "setAttributeDataField",
    setModal = "setModal",
}

export type SidebarReducerActions =
    | { type: SidebarReducerActionName.setModal; payload: ModalState }
    | { type: SidebarReducerActionName.setAttributeDataField; payload: DataField }
    | {
          type: SidebarReducerActionName.setObjectDetailsMinimised | SidebarReducerActionName.setTransitionCompleted | SidebarReducerActionName.setShowAttributeModal;
          payload: boolean;
      };

export const SidebarReducerActionTypes = {
    setObjectDetailsMinimised: SidebarReducerActionName.setObjectDetailsMinimised,
    setTransitionCompleted: SidebarReducerActionName.setTransitionCompleted,
    setShowAttributeModal: SidebarReducerActionName.setShowAttributeModal,
    setAttributeDataField: SidebarReducerActionName.setAttributeDataField,
    setModal: SidebarReducerActionName.setModal,
} as const;
